import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Kaart from '../components/Kaart';
import Item from '../components/Item';
import Still from '../components/Still';
import Video from '../components/Video';
import KaartReunies from '../components/KaartReunies';
import VideoReunies from '../components/VideoReunies';
import StillReunies from '../components/StillReunies';
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/kaart',
    name: 'kaart',
    component: Kaart
  },
  {
    path: '/item/:itemId',
    name: 'item',
    component: Item,
    props: true
  },
  {
    path: '/still/:fileId',
    name: 'still',
    component: Still,
    props: true
  },
  {
    path: '/video/:fileId',
    name: 'video',
    component: Video,
    props: true
  },
  {
    path: '/reuniekaart',
    name: 'reuniekaart',
    component: KaartReunies,
    props: true
  },
  {
    path: '/reunievideo/:fileId',
    name: 'reunievideo',
    component: VideoReunies,
    props: true
  },
  {
    path: '/reuniestill/:fileId',
    name: 'reuniestill',
    component: StillReunies,
    props: true
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
